// extracted by mini-css-extract-plugin
export var ellipsesOverflow = "_co-a";
export var fulfillmentFormRail = "_co-9";
export var headerTitleRow = "_co-c";
export var orderDetailsWrapper = "_co-7";
export var orderLinkTrigger = "_co-2";
export var paymentInformationGrid = "_co-h";
export var paymentSummaryColumn = "_co-i";
export var shipmentContainer = "_co-b";
export var shipmentDetailsMainPane = "_co-8";
export var shipmentNavigationCard = "_co-5";
export var shipmentNavigationRail = "_co-3";
export var shipmentNavigationRailHeader = "_co-4";
export var shipmentSummaryFact = "_co-e";
export var shipmentSummaryGrid = "_co-d";
export var shipmentSummaryMetadataRow = "_co-f";
export var shipmentSummaryTags = "_co-g";
export var shipmentWorkspace = "_co-0";
export var shipmentWorkspaceContent = "_co-6";
export var shipmentWorkspaceHeader = "_co-1";